import { useSeo } from '../lib/seo';
import React, { useEffect, useState } from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import api from '../lib/api';

export default function PackagesPage() {
  useSeo(
    'Family Friendly Great Value Stay, Play & Explore Holiday Breaks',
    'Curated Stay, Play & Explore short breaks in Leicestershire: one great-value price covers your hotel stay, breakfast and entry to top family attractions — the same price every weekend, even in school holidays. The easy, affordable way to book a family getaway.'
  );
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/packages').then((r) => setItems(r.data.items)); }, []);
  return (
    <div>
      {/* hero */}
      <div className="bg-heritage text-base py-20 relative overflow-hidden">
        <div className="absolute inset-0 grain" />
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
          <div className="label text-mustard mb-4">Stay · Play · Explore</div>
          <h1 className="font-display text-5xl lg:text-8xl leading-[0.92] max-w-4xl">Short breaks that <em className="not-italic text-mustard">don't punish you</em> for booking in school holidays.</h1>
          <p className="mt-8 text-xl text-base/85 max-w-2xl">Hotel + breakfast + attraction tickets, bundled for a family of four. One flat price, every weekend of the year.</p>
          <p className="mt-4 text-base/75 max-w-2xl">Travelling without the kids? <strong className="text-mustard">The Perfect Break</strong> bundles adults-only stays with hand-picked experiences from £169 for two — look for the &quot;Adults only&quot; badge below.</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((p, i) => (
          <a key={p.id} href={p.book_url} target="_blank" rel="noreferrer" data-testid={`package-card-${p.slug}`} className="group bg-white border border-charcoal/10 rounded-[2rem] overflow-hidden block hover:-translate-y-1 transition-transform">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img src={p.hero_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              {p.badge && <span className="absolute top-5 left-5 bg-charcoal text-base text-xs font-semibold px-3 py-1.5 rounded-full">{p.badge}</span>}
              <span className="absolute top-5 right-5 bg-mustard text-charcoal text-sm font-semibold px-4 py-2 rounded-full">From {p.price_from}</span>
            </div>
            <div className="p-8">
              <h3 className="font-display text-2xl leading-tight mb-2">{p.title}</h3>
              <p className="text-muted text-sm mb-3">{p.subtitle}</p>
              {p.description && <p className="text-charcoal/75 text-sm leading-relaxed mb-5" data-testid={`package-desc-${p.slug}`}>{p.description}</p>}
              <ul className="space-y-2.5 mb-6">
                {p.includes?.map((inc, j) => (
                  <li key={j} className="flex items-start gap-2.5 text-sm">
                    <Check size={16} className="text-forest mt-0.5 shrink-0"/>
                    <span>{inc}</span>
                  </li>
                ))}
              </ul>
              <div className="inline-flex items-center gap-2 text-heritage font-semibold">Book this break <ArrowUpRight size={16}/></div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
